

import Button from '../../../components/base/Button';

export default function ContactSection() {
  const handleConsultationClick = () => {
    window.REACT_APP_NAVIGATE('/consultation');
  };

  return (
    <section id="contact" className="py-20 bg-gradient-to-b from-[#F0F0F0] to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-black mb-4">
            Visit Our <span className="text-[#8A4F8A]">Wellness Center</span>
          </h2>
          <p className="text-xl text-[#B0B0B0] max-w-3xl mx-auto">
            Located in the heart of Washington, D.C., our state-of-the-art facility provides a comfortable and professional environment for your wellness journey.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Information */}
          <div className="space-y-8">
            <div className="bg-white rounded-xl p-8 shadow-lg">
              <h3 className="text-2xl font-bold text-black mb-6">Get in Touch</h3>
              
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-[#8A4F8A] rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-map-pin-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-black mb-1">Address</h4>
                    <p className="text-[#B0B0B0]">
                      1160 Varnum Street N.E<br />
                      Washington, D.C 20017<br />
                      Suite #218
                    </p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-[#8A4F8A] rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-phone-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-black mb-1">Phone</h4>
                    <a href="tel:202-883-6057" className="text-[#8A4F8A] hover:text-[#7A3F7A] font-semibold">
                      (202) 883-6057
                    </a>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-[#8A4F8A] rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-time-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-black mb-1">Hours</h4>
                    <div className="text-[#B0B0B0]">
                      <p>Monday - Friday: 9:00 AM - 6:00 PM</p>
                      <p>Saturday: 9:00 AM - 3:00 PM</p>
                      <p>Sunday: Closed</p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="mt-8 pt-6 border-t border-[#D0D0D0]">
                <h4 className="font-semibold text-black mb-4">Ready to Start Your Journey?</h4>
                <div className="space-y-3">
                  <Button className="w-full" onClick={handleConsultationClick}>
                    <i className="ri-calendar-line mr-2"></i>
                    Book Your Consultation
                  </Button>
                  <Button variant="outline" className="w-full" onClick={() => window.open('tel:202-883-6057', '_self')}>
                    <i className="ri-phone-line mr-2"></i>
                    Call Now
                  </Button>
                </div>
              </div>
            </div>
          </div>

          {/* Map */}
          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <div className="h-96 lg:h-full min-h-[400px]">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3104.5234567890123!2d-77.0123456789!3d38.9123456789!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2s1160%20Varnum%20Street%20NE%2C%20Washington%2C%20DC%2020017!5e0!3m2!1sen!2sus!4v1234567890123"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Renew Integrative Wellness Location"
              ></iframe>
            </div>
          </div>
        </div>

        {/* Emergency Contact */}
        <div className="mt-12 bg-gradient-to-r from-[#C8A2C8] to-[#8A4F8A] rounded-xl p-6 text-center text-white">
          <div className="flex items-center justify-center mb-3">
            <i className="ri-alert-line text-2xl mr-2"></i>
            <h4 className="text-lg font-semibold">Need Immediate Assistance?</h4>
          </div>
          <p className="text-lg mb-4 opacity-90">
            For urgent medical concerns, please call our office or visit your nearest emergency room.
          </p>
          <a 
            href="tel:202-269-6600" 
            className="inline-flex items-center bg-white text-[#8A4F8A] px-6 py-3 rounded-lg font-semibold hover:bg-[#F0F0F0] transition-colors whitespace-nowrap"
          >
            <i className="ri-phone-line mr-2"></i>
            Call (202) 269-6600
          </a>
        </div>
      </div>
    </section>
  );
}

